// extracted by mini-css-extract-plugin
export default {"logoIcon":"options_logoIcon__F5dR7","textFieldRename":"options_textFieldRename__omTL3"};